import React, { useEffect, useState } from 'react';
import styles from './ErrorReportDialog.module.css';

export interface ErrorReportDialogProps {
  reportText: string;
  onClose: () => void;
}

const METRICA_SUPPORT_EMAIL = 'info@metrica.co.il';

const ErrorReportDialog: React.FC<ErrorReportDialogProps> = ({
  reportText,
  onClose,
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleBackdropClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(reportText);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      const textarea = document.createElement('textarea');
      textarea.value = reportText;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div
        className={styles.dialog}
        role="alertdialog"
        aria-labelledby="error-report-title"
        aria-describedby="error-report-instruction"
      >
        <div className={styles.header}>
          <div className={styles.icon} aria-hidden>
            ×
          </div>
          <h3 id="error-report-title" className={styles.title}>
            אירעה שגיאה
          </h3>
        </div>

        <div className={styles.body}>
          <p id="error-report-instruction" className={styles.instruction}>
            אנא העתיקו את פרטי השגיאה שלהלן ושלחו ל-{METRICA_SUPPORT_EMAIL} לבדיקה וטיפול.
          </p>
          <pre className={styles.reportBox}>{reportText}</pre>
        </div>

        <div className={styles.actions}>
          <button type="button" className={`${styles.button} ${styles.buttonSecondary}`} onClick={onClose}>
            סגור
          </button>
          <button
            type="button"
            className={`${styles.button} ${styles.buttonPrimary}`}
            onClick={handleCopy}
            autoFocus
          >
            {copied ? 'הועתק' : 'העתק'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorReportDialog;
